import { Contract, type ContractRunner } from "ethers";
import { ERC20Abi, WETHAbi } from "../abis";

export class TokenService {
  async allowance(
    tokenAddress: string,
    owner: string,
    spender: string,
    runner: ContractRunner,
  ): Promise<bigint> {
    const contract = new Contract(tokenAddress, ERC20Abi, runner) as any;
    return (await contract.allowance(owner, spender)) as bigint;
  }

  async approve(
    tokenAddress: string,
    spender: string,
    amount: bigint,
    runner: ContractRunner,
    overrides: Record<string, unknown> = {},
  ) {
    const contract = new Contract(tokenAddress, ERC20Abi, runner) as any;
    return contract.approve(spender, amount, overrides);
  }

  async balanceOf(
    tokenAddress: string,
    owner: string,
    runner: ContractRunner,
  ): Promise<bigint> {
    const contract = new Contract(tokenAddress, ERC20Abi, runner) as any;
    return (await contract.balanceOf(owner)) as bigint;
  }

  async decimals(tokenAddress: string, runner: ContractRunner): Promise<number> {
    const contract = new Contract(tokenAddress, ERC20Abi, runner) as any;
    return Number(await contract.decimals());
  }

  async wrapNative(
    amount: bigint,
    wethAddress: string,
    runner: ContractRunner,
    overrides: Record<string, unknown> = {},
  ) {
    const contract = new Contract(wethAddress, WETHAbi, runner) as any;
    return contract.deposit({ value: amount, ...overrides });
  }
}
